export default function getCoinPrice(coin): string {
  if (coin) return coin.priceUSD.avg;
  return '0';
}
